import { Component, Input, OnInit } from '@angular/core';
import { OffersOfApplication } from '../../../type/result_type';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.scss'],
})
export class SliderComponent implements OnInit {
  @Input() offersData: OffersOfApplication[] = [];
  @Input() eternalPage!: boolean;
  @Input() resultPage!: boolean;

  public counter: number = 0;
  public activeDot: number = 0;
  public closeDetail: boolean = false;

  constructor() {}

  ngOnInit(): void {
    this.checkElement();
  }

  clickPrevious(): void {
    this.closeDetails();
    --this.counter;
    document
      .getElementById('card_' + this.counter)
      .scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  clickNext(): void {
    this.closeDetails();
    ++this.counter;
    document
      .getElementById('card_' + this.counter)
      .scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }

  //---check what element is on visible---
  checkElement(): void {
    const sections = document.querySelectorAll('.slider .container__card');
    const options = {
      rootMargin: '0px',
      threshold: 0.25,
    };
    const callback = (entries) => {
      entries.forEach((entry) => {
        const { target } = entry;
        if (entry.intersectionRatio >= 0.75) {
          //---make an active dot---
          this.activeDot = target.id.split('_').pop();
          //---make an active dot---
        }
      });
    };
    const observer = new IntersectionObserver(callback, options);
    sections.forEach((section) => {
      observer.observe(section);
    });
  }
  //---check what element is on visible---

  closeDetails(): void {
    this.closeDetail = true;
  }

  trackByOfferId(index: number, offer: OffersOfApplication): string {
    return offer.id;
  }
}
